import React from 'react';
import { IPreloadCacheContext } from 'framework/context/IPreloadCacheContext';
import { IRoomsCache } from 'gen/ApiClient';

export const RoomsPreloadCacheContext = React.createContext<IPreloadCacheContext<IRoomsCache>>(undefined as any);
